<template>
  <div class="customPaginationTable" :style="openUnselectMode ? 'margin-top: 50px' : ''">
    <el-checkbox v-if="openUnselectMode" class="allSelectMode_button" :indeterminate="allSelectMode_button_isIndeterminate" v-model="allSelectMode_button_checkAll" @change="allSelectMode_button_handleCheckAllChange">所有页面全部选择</el-checkbox>
    <!-- <el-button class="allSelectMode_button" size="small" :type="allSelectMode ? 'danger' : ''" @click="allSelectModeChange">{{ allSelectMode ? "关闭" : "开启" }}全选模式</el-button> -->
    <el-table
      ref="table"
      v-loading="listLoading"
      :data="tableData"
      border
      :current-row-key="tableSetting.currentRowKey"
      :row-key="tableSetting.rowKey || 'id'"
      :show-header="tableSetting.showHeader"
      :tree-props="tableSetting.treeProps"
      :highlight-current-row="true"
      :cell-style="tableSetting.cellStyle"
      :height="tableSetting.height"
      :max-height="tableSetting.maxHeight"
      :fit="true"
      @sort-change="onSortChange"
      @selection-change="onSelectionChange"
      @select-all="onSelectAll"
      @select="onSelect"
      :header-cell-style="tableSetting.headerCellStyle ? tableSetting.headerCellStyle : {}"
    >
      <slot name="expand"></slot>
      <!--渲染字段列-->
      <template v-for="(columnItem, index) in tableColumns">
        <template v-if="!columnItem">-</template>
        <template v-else-if="columnItem.tip">
          <slot v-if="columnItem.slot" :name="'slot-' + columnItem.prop" v-bind:columnItem="columnItem"></slot>
          <el-table-column v-else :label="columnItem.label" :min-width="columnItem.width ? columnItem.width : '150'" :key="index + 1" :prop="columnItem.prop" :show-overflow-tooltip="true" :sortable="columnItem.sortable" :fixed="columnItem.fixed" :formatter="columnItem.formatter ? columnItem.formatter : commonFormatter" :align="columnItem.align">
            <template slot="header">
              {{ columnItem.label }}
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">
                  <span v-html="columnItem.tipLabel"></span>
                </div>
                <i class="el-icon-question" @click.stop="tooltipOnClick(columnItem.prop)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </template>
        <template v-else-if="columnItem.slot">
          <slot :name="'slot-' + columnItem.prop" v-bind:columnItem="columnItem"></slot>
        </template>
        <template v-else-if="columnItem.type === 'labels'">
          <el-table-column :key="index + 1" :label="columnItem.label" :width="columnItem.width ? columnItem.width : '320'">
            <template slot-scope="scope">
              <div v-if="scope.row[columnItem.prop] && scope.row[columnItem.prop].length > 0">
                <el-tag type="info" :key="index" v-for="(tag, index) in scope.row[columnItem.prop]">
                  {{ tag }}
                </el-tag>
                <!-- <el-popover placement="top-start" :title="columnItem.label" width="200" trigger="hover" v-if="scope.row[columnItem.prop].length > 2">
                  <el-tag type="info" :key="index" v-for="(tag, index) in scope.row[columnItem.prop]">
                    {{ tag }}
                  </el-tag>
                  <el-button type="text" slot="reference" v-if="scope.row[columnItem.prop].length > 2">
                    <i class="el-icon-more"></i>
                  </el-button>
                </el-popover> -->
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
        </template>
        <template v-else-if="columnItem.type === 'selection'">
          <el-table-column type="selection" :reserve-selection="allSelectMode ? false : columnItem.reserveSelection ? columnItem.reserveSelection : false" :key="index + 1" :selectable="columnItem.selectable" :fixed="columnItem.fixed" :width="columnItem.width ? columnItem.width : '55'"></el-table-column>
        </template>
        <template v-else-if="columnItem.type === 'index'">
          <el-table-column type="index" :key="index + 1" :label="columnItem.label" :width="columnItem.width ? columnItem.width : '55'" :index="columnItem.indexFunction ? columnItem.indexFunction : ''"></el-table-column>
        </template>
        <template v-else-if="columnItem.html">
          <el-table-column
            :type="columnItem.type"
            :label="columnItem.label"
            :min-width="columnItem.width ? columnItem.width : '150'"
            :width="columnItem.type == 'index' ? '50' : ''"
            :key="index + 1"
            :prop="columnItem.prop"
            :fixed="columnItem.fixed"
            :align="columnItem.align"
            :show-overflow-tooltip="true"
            :sortable="columnItem.sortable"
            :formatter="columnItem.formatter ? columnItem.formatter : commonFormatter"
          >
            <template slot-scope="scope">
              <div v-html="scope.row[columnItem.prop]"></div>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column
            :type="columnItem.type"
            :label="columnItem.label"
            :min-width="columnItem.width ? columnItem.width : '150'"
            :width="columnItem.type == 'index' ? '50' : ''"
            :key="index + 1"
            :prop="columnItem.prop"
            :fixed="columnItem.fixed"
            :align="columnItem.align"
            :show-overflow-tooltip="true"
            :sortable="columnItem.sortable"
            :formatter="columnItem.formatter ? columnItem.formatter : commonFormatter"
          />
        </template>
      </template>
      <slot name="lastColumn"></slot>
    </el-table>
    <pagination v-if="!tableSetting.closePagination" :disabled="listLoading" :total="listQuery.totalNum" :currentPage.sync="currentPage" :page-sizes="pageSizes" :pageSize.sync="limit" @pagination="onPaginationChange" />
  </div>
</template>
<script>
  import Pagination from "@components/Pagination";
  import stackyMixins from "@mixins/table-sticky";
  export default {
    name: "customPaginationTable",
    components: {
      Pagination,
    },
    mixins: [stackyMixins],
    data() {
      return {
        parent: "customPaginationTable",
        showSelection: true,
        allSelectMode_button_isIndeterminate: false,
        allSelectMode_button_checkAll: false,
        tableData: [],
        commonFormatter: null,
        allSelectMode: false,
        allSelectMode_unselectList: [],
        tableColumns: [],
        listLoading: false,
        tableSetting: {},
        listQuery: {
          totalNum: "",
          currentPageNum: 1,
          pageSize: 10,
          sortFields: [],
        },
        selectableFunc: () => {
          return true;
        },
      };
    },

    props: {
      maxSelectNum: {
        type: Number,
        default: 9999,
      },
      openUnselectMode: {
        type: Boolean,
        default: false,
      },
      isSticky: {
        type: Boolean,
        default: false,
      },
      formatter: {
        type: Function,
        default: function (row, column, cellValue) {
          return cellValue;
        },
      },
      columns: {
        type: Array,
        default: function () {
          return [];
        },
      },
      data: {
        type: Array,
        default: function () {
          return [];
        },
      },
      loading: {
        type: Boolean,
        default: false,
      },
      settings: {
        type: Object,
        default: function () {
          return {};
        },
      },
      defaultOrder: {
        type: Object,
        default: function () {
          return {};
        },
      },
      totalNum: {
        type: Number,
        default: 0,
      },
      currentPageNum: {
        type: Number,
        default: 0,
      },
      pageSize: {
        type: Number,
        default: 10,
      },
      pageSizes: {
        type: Array,
        default: () => {
          return [10, 20, 30, 50, 70, 100];
        },
      },
    },
    watch: {
      formatter() {
        this.commonFormatter = this.formatter;
      },
      columns() {
        this.tableColumns = this.columns;
      },
      data() {
        this.tableData = this.data;
        // console.log("setSelect_allSelectModedata");
        if (this.allSelectMode) {
          // this.refresh_allSelectMode_unselectList();
          this.$nextTick(() => {
            this.setSelect_allSelectMode();
          });
        }
      },
      totalNum() {
        this.listQuery.totalNum = this.totalNum;
      },
      loading() {
        this.listLoading = this.loading;
      },
      settings() {
        this.tableSetting = this.settings;
      },
      defaultOrder() {
        this.listQuery.sortFields = [this.defaultOrder];
      },
    },
    computed: {
      currentPage: {
        get() {
          return this.currentPageNum;
        },
        set(val) {
          this.listQuery.currentPageNum = val;
          this.$emit("update:currentPageNum", val);
        },
      },
      limit: {
        get() {
          return this.pageSize;
        },
        set(val) {
          this.listQuery.pageSize = val;
          this.$emit("update:pageSize", val);
        },
      },
    },
    created() {
      this.commonFormatter = this.formatter;
      this.tableColumns = this.columns;

      this.tableData = this.data;
      this.listLoading = this.loading;
      this.tableSetting = this.settings;
      this.listQuery.totalNum = this.totalNum;
      this.listQuery.sortFields = this.defaultOrder.order ? [this.defaultOrder] : [];
      this.$emit("init-data", this.listQuery);
    },
    methods: {
      selectable(item) {
        if (this.columns[0].type == "selection" && this.columns[0].selectable) {
          return this.columns[0].selectable(item);
        } else {
          return true;
        }
      },
      allSelectMode_button_handleCheckAllChange(val) {
        this.allSelectMode_button_isIndeterminate = false;
        this.showSelection = false;
        this.allSelectMode = val;
        this.$emit("unselection-mode-change", this.allSelectMode);

        this.$refs.table.clearSelection();

        this.allSelectMode_unselectList = [];
        if (this.allSelectMode) {
          // this.$refs.table.toggleAllSelection();
          this.setSelect_allSelectMode();
        }

        this.onSelectionChange([]);
        this.$nextTick(() => {
          this.showSelection = true;
        });
      },
      clearSelection() {
        this.$refs.table.clearSelection();
      },
      // allSelectModeChange() {
      //   this.allSelectMode = !this.allSelectMode;
      //   this.allSelectMode_unselectList = [];
      //   this.$refs.table.clearSelection();
      //   if (this.allSelectMode) {
      //     // this.$refs.table.toggleAllSelection();
      //     this.setSelect_allSelectMode();
      //   }

      //   this.onSelectionChange([]);
      // },
      toggleRowSelection(row, selected) {
        this.$refs.table.toggleRowSelection(row, selected);
      },
      setSelect_allSelectMode() {
        // console.log("setSelect_allSelectMode");
        this.tableData.forEach((item) => {
          let select = !this.allSelectMode_unselectList.some((unitem) => {
            return unitem.id == item.id;
          });
          let selectable = this.selectable(item);
          if (select && selectable) {
            this.$refs.table.toggleRowSelection(item, true);
          }
        });

        // this.$refs.table.toggleAllSelection();
        // this.allSelectMode_unselectList.forEach((unselect) => {

        //   this.$refs.table.toggleRowSelection(
        //     this.tableData.find((item) => {
        //       return unselect.id == item.id;
        //     }),
        //     false
        //   );
        // });
      },
      onSelectionChange(event) {
        // console.log("onSelectionChange", this.allSelectMode_unselectList, this.allSelectMode);
        if (this.allSelectMode) {
          if (this.allSelectMode_unselectList.length > 0) {
            this.allSelectMode_button_isIndeterminate = true;
            this.allSelectMode_button_checkAll = false;
          } else {
            this.allSelectMode_button_isIndeterminate = false;
            this.allSelectMode_button_checkAll = true;
          }
          this.$emit("unselection-change", this.allSelectMode_unselectList);
          this.$emit("selection-change", []);
        } else {
          this.$emit("unselection-change", []);

          this.$emit("selection-change", event);
        }
      },
      onSelectAll(selection) {
        this.$emit("select-all", selection);
        console.log("onSelectAll", selection);
        if (this.allSelectMode) {
          let clearMode = selection.length == 0;

          this.tableData.forEach((item) => {
            let unselectIndex = this.allSelectMode_unselectList.findIndex((unselect) => {
              return item.id == unselect.id;
            });
            // console.log("onSelectAll", unselectIndex, clearMode);
            if (unselectIndex >= 0) {
              //只有全选 ,等于需要把原来存在于黑名单中的 ,需要删除掉

              if (!clearMode) {
                console.log("onSelectAll", "删除");

                this.allSelectMode_unselectList.splice(unselectIndex, 1);
              }
            } else {
              //只有全不选 ,原来不在黑名单中的 ,需要推入
              if (clearMode) {
                console.log("onSelectAll", "推入");

                this.allSelectMode_unselectList.push(item);
              }
            }
          });
          this.onSelectionChange(this.allSelectMode_unselectList);
        }
      },
      onSelect(selection, row) {
        this.$emit("select", selection, row);
        if (this.allSelectMode) {
          let selected = selection.some((selected) => {
            return row.id == selected.id;
          });

          if (selected) {
            let findIndex = this.allSelectMode_unselectList.findIndex((item) => {
              return item.id == row.id;
            });
            if (findIndex >= 0) {
              this.allSelectMode_unselectList.splice(findIndex, 1);
            }
          } else {
            this.allSelectMode_unselectList.push(row);
          }
        }
      },
      onPaginationChange() {
        // console.log("onPaginationChange");
        this.emitConditionChange();
      },
      emitConditionChange() {
        this.$emit("condition-change", this.listQuery);
      },
      onSortChange: function (event) {
        const prop = event.prop;
        let order = event.order;
        // this.listQuery.orders = {};
        let orderCode = 0;
        if (order == "descending") {
          orderCode = "DESC";
        } else if (order == "ascending") {
          orderCode = "ASC";
        } else {
          orderCode = "";
        }
        this.currentPage = 1;
        this.listQuery.sortFields = [];
        if (orderCode) {
          this.listQuery.sortFields.push({ propName: prop, order: orderCode });
        }
        this.emitConditionChange();
      },
      getTableInstance() {
        return this.$refs.table;
      },
      tooltipOnClick(prop) {
        console.log(prop);
        this.$emit("tooltip-on-click", prop);
      },
    },
  };
</script>
<style lang="less" scoped>
  .customPaginationTable {
    position: relative;
    .allSelectMode_button {
      position: absolute;
      top: -35px;
      left: 10px;
    }
  }
</style>
